module.exports = function ($) {
    return {
        init: function () {
            $(".accordion").click(function (e) {
                var accordion = $(this);
                if (e.target.nodeName == 'INPUT')
                {
                    // Don't do anything
                    //console.log('search');
                }
                else
                {
                    $(".accordion", accordion).removeClass("show");
                    $(".accordion", accordion).parents("section").removeClass("show");
                    accordion.toggleClass("show");
                    accordion.parents("section").toggleClass("show");
                }
                
                e.stopPropagation();
            });
        }
    }
}